import Main from '@/views/main.vue';
import * as error from './childrenRouter/error';
import { quotaApplication } from './childrenRouter/quotaApplication';
//不作为main组件的子页面展示的页面单独写
export const loginRouter =[ {
    path: '/login',
    name: 'login',
    meta: {
        title: 'Login - 登录'
    },
    component: () =>
        import ('@/views/login.vue')
}, {
  path: '/loginhtml',
  name: 'loginhtml',
  meta: {
    title: 'Login - 登录'
  },
  component: () =>
    import ('@/views/loginhtml.vue')
}
];

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () =>
        import ('@/views/main-components/lockscreen/components/locking-page.vue')
};
export const farmDetail = {
  path:'/farmDetail',
  name:'farmDetail',
  // meta:{
  //   keepAlive:true
  // },
  component:()=>import('@/views/system/traffic/wisdomJ/FarmDetail/index.vue')
}
export const serviceSiteDetail = {
  path:'/serviceSiteDetail',
  name:'serviceSiteDetail',
  // meta:{
  //   keepAlive:true
  // },
  component:()=>import('@/views/system/traffic/wisdomJ/serviceSiteDetail/index.vue')
}
export const CommunityServiceSiteDetail = {
  path:'/CommunityServiceSiteDetail',
  name:'CommunityServiceSiteDetail',
  // meta:{
  //   keepAlive:true
  // },
  component:()=>import('@/views/system/traffic/wisdomJ/CommunityServiceSiteDetail/index.vue')
}
export const orderDetail = {
  path:'/orderDetail',
  name:'orderDetail',
  // meta:{
  //   keepAlive:true
  // },
  component:()=>import('@/views/system/traffic/wisdomJ/order/demo.vue')
}
export const dongHengDetail = {
  path:'/dongHengDetail',
  name:'dongHengDetail',
  // meta:{
  //   keepAlive:true
  // },
  component:()=>import('@/views/system/traffic/wisdomJ/serviceSiteDetail/demo.vue')
}




export const pathTest = {};

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export let otherRouter = {
    path: '/',
    name: 'otherRouter',
    redirect: '/home',
    component: Main,
    children: [{
        path: 'home',
        title: '首页',
        name: 'home_index',
        meta:{
          keepAlive:true
        },
        component: () =>
            import ('@/views/system/traffic/wisdomJ/indexauto.vue')
    }, {
        path: 'indexhome',
        title: '首页',
        name: 'indexhome',
        meta:{
          keepAlive:true
        },
        component: () =>
            import ('@/views/system/traffic/wisdomJ/wisdom.vue')
    }, {
        path: 'dispatch',
        title: '订单派单',
        name: 'dispatch',
        component: () =>
            import ('@/views/system/dispatch/wisdomJ/wisdom.vue')
    },
      {
        path: 'demo',
        title: '订单派单',
        name: 'demo',
        component: () =>
          import ('@/views/system/traffic/wisdomJ/order/demo.vue')
      }
    ],

};

//作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
    quotaApplication,
    {
        path: '/ownspace',
        title: '个人中心',
        name: 'ownspace',
        component: () =>
            import ('@/views/own-space/own-space.vue')
    }
];

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
    ...loginRouter,
    otherRouter,
    locking,
    ...appRouter,
    ...error,
    orderDetail,
    farmDetail,
    serviceSiteDetail,
    CommunityServiceSiteDetail,
    dongHengDetail
];



// WEBPACK FOOTER //
// ./src/router/router.js